import { render } from "./my-trades.vue?vue&type=template&id=33cb4164"
import script from "./my-trades.vue?vue&type=script&lang=js"
export * from "./my-trades.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__